module.exports = __webpack_public_path__ + "img/제주도 카페.77b80410.png";